<h1 mat-dialog-title>
  <ng-container>
    <span>Create New FSPS Quote</span>
  </ng-container>
</h1>

<div mat-dialog-content #modalContainer scrollInsetShadow>
  <form name="quote-create-form" #quoteCreateForm="ngForm" style="padding-bottom: 15px;">
    <vendor-quote-filter [VendorId]="Quote.VendorId"
                         [ValuesRequired]="true"
                         (YearSelected)="Quote.Year = $event"
                         (FieldScientistSelected)="Quote.FieldScientistId = $event"
                         (ContactSelected)="Quote.ContactId = $event"></vendor-quote-filter>
</form>
</div>

<div mat-dialog-actions style="display: flex">
  <span style="flex: 1 1 auto;"></span>
  <button mat-raised-button color="accent" (click)="CancelModal()">Cancel</button>
  <button mat-raised-button color="primary" (click)="SaveQuote(quoteCreateForm)">Create</button>
</div>
